import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  InputMaybe,
  UpdateObligationAssessmentResultMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateObligationAssessmentResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface UpdateObligationAssessmentResultInput {
  Id: string;
  Rating?: InputMaybe<number>;
  Rationale?: InputMaybe<string>;
  TestDate?: InputMaybe<string>;
  CustomAttributeData?: InputMaybe<CustomAttributeData>;
}

export const useUpdateObligationAssessmentResult = createMutationHook({
  name: 'updateObligationAssessmentResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.obligationAssessmentResult.update.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateObligationAssessmentResultInput) => input,
  // Invalidation parity with the legacy Apollo evictFields:
  // obligation_assessment_result (+ aggregate) and assessment.
  invalidate: (trpc) => [
    trpc.frontend.obligationAssessmentResult.pathKey(),
    trpc.frontend.assessment.pathKey(),
  ],
  // The tRPC update either succeeds on exactly one row or throws, so a
  // successful response always maps to affected_rows: 1.
  mapResponse: (): UpdateObligationAssessmentResultMutation => ({
    update_obligation_assessment_result: {
      __typename: 'obligation_assessment_result_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateObligationAssessmentResultDocument,
  graphqlVariables: (input: UpdateObligationAssessmentResultInput) => ({
    ...input,
  }),
  evictFields: [
    'obligation_assessment_result',
    'assessment',
    'obligation_assessment_result_aggregate',
  ],
});
